<div class="card">
  <div class="card-body p-0">
    <div class="filter-form">
      <ng-content></ng-content>
      <div class="row">
        <div class="filter-lg-flex filter-lg-none col-12">
          <div class="flex-gap-5" [ngClass]="{ invisible: !(filters && entity), 'mr-auto': !isInProducts }">
            <modal-export-create
              *ngIf="isExportButtonShown"
              [isInFilterForm]="true"
              [filters]="filters"
              [entity]="entity"
              (onResult)="triggerExportResult($event)"
              data-cy="create-export"
            ></modal-export-create>
            <modal-bulk-edits
              *ngIf="showBulkEditsBtn"
              [checkedProducts]="checkedProducts"
              [allProductsSelected]="areAllProductsChecked"
              [filters]="filters"
              (refreshProductsPage)="refreshProduct()"
              (setCheckedProductsToFalse)="setCheckedProductsToFalseMethod()"
              data-cy="bulk-edit-products"
            >
            </modal-bulk-edits>
            <btn
              *ngIf="showEditMetricsBtn && !isEditingMetrics"
              [btnType]="'bulk.edit.metrics'"
              [icon]="'far-edit'"
              (onEvent)="editMetrics()"
              [label]="'bulk.edit.metrics'"
              [classes]="['btn-third', 'float-right', 'mr-2']"
              data-cy="edit-metrics"
              [title]="'bulk.edit.metrics' | translate"
            ></btn>
            <btn
              *ngIf="showEditMetricsBtn && isEditingMetrics"
              [btnType]="'bulk.edit.metrics.save'"
              [icon]="'far-check'"
              (onEvent)="saveMetrics()"
              [label]="'bulk.edit.metrics.save'"
              [classes]="['btn-first', 'float-right', 'mr-2']"
              data-cy="edit-metrics"
              [isLoading]="metricsLoading"
              [spinnerClassesString]="'spinner-white'"
              [title]="'bulk.edit.metrics' | translate"
            ></btn>
            <btn
              *ngIf="showEditMetricsBtn && isEditingMetrics"
              [btnType]="'bulk.edit.metrics.editing.mode.cancel'"
              [icon]="'far-times'"
              (onEvent)="cancelEditingMetrics()"
              [label]="'bulk.edit.metrics.editing.mode.cancel'"
              [classes]="['btn-third', 'mr-2']"
              data-cy="cancel-editing-metrics"
              [title]="'bulk.edit.metrics.editing.mode.cancel' | translate"
            ></btn>
            <app-exports *ngIf="areExportsInFilter" [entity]="entity"></app-exports>
          </div>
          <div
            class="filter align-self-center"
            (click)="triggerOnVisibilityChange()"
            (keyup)="triggerOnVisibilityChange()"
            tabindex="-1"
            [ngClass]="{ invisible: isFilterInvisible, 'margin-0-auto': isInProducts }"
          >
            <div class="flex-gap-5 align-items-center">
              <i [ngClass]="{ rotate: filterVisible }" class="fa fa-chevron-down" data-cy="filter"></i>
              <div>
                {{ (filterVisible ? 'filters.hide' : 'filters.show') | translate }}
              </div>
            </div>
          </div>
          <div class="flex-gap-5 flex-row-reverse ml-auto flex-wrap">
            <btn
              [btnType]="'submit'"
              [icon]="'far-search'"
              (onEvent)="triggerOnSubmit()"
              [label]="'filter'"
              [classes]="['btn-first']"
              data-cy="submit-filter"
              [title]="'filter' | translate"
            ></btn>
            <btn
              [btnType]="'button'"
              [icon]="'far-times'"
              (onEvent)="triggerOnClear()"
              [label]="'clear'"
              [classes]="['btn-third']"
              data-cy="cancel-filter"
              [title]="'clear' | translate"
            ></btn>
          </div>
        </div>

        <div class="filter-md-flex filter-md-none col-12 filter-responsive">
          <div
            class="filter align-self-center"
            (click)="triggerOnVisibilityChange()"
            (keyup)="triggerOnVisibilityChange()"
            tabindex="-1"
            [ngClass]="{ invisible: isFilterInvisible }"
          >
            <div class="flex-gap-5 align-items-center">
              <i [ngClass]="{ rotate: filterVisible }" class="fa fa-chevron-down" data-cy="filter"></i>
              <div>
                {{ (filterVisible ? 'filters.hide' : 'filters.show') | translate }}
              </div>
            </div>
          </div>
          <div class="flex-gap-5 flex-row-reverse flex-wrap filter-row">
            <btn
              [btnType]="'submit'"
              [icon]="'far-search'"
              (onEvent)="triggerOnSubmit()"
              [label]="'filter'"
              [title]="'filter' | translate"
              [classes]="['btn-first']"
              [ngClass]="'btn-first-wrap'"
            ></btn>
            <btn
              [btnType]="'button'"
              [icon]="'far-times'"
              (onEvent)="triggerOnClear()"
              [label]="'clear'"
              [title]="'clear' | translate"
              [classes]="['btn-third']"
            ></btn>
            <modal-export-create
              *ngIf="isExportButtonShown"
              [filters]="filters"
              [entity]="entity"
              (onResult)="triggerExportResult($event)"
            ></modal-export-create>
            <app-exports *ngIf="areExportsInFilter" [entity]="entity"></app-exports>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
